import { createStyles, makeStyles, Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import type { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import React from 'react';
import { FavoriteBorder, Favorite } from '@material-ui/icons';
import { useRecoilValue } from 'recoil';
import clsx from 'clsx';
import { useToggleIsFavorite, isFavoriteProductSelector } from '../../../api/products/favoriteProducts';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export type ProductDetailFavoriteToggleClassKey = 'root';

export interface ProductDetailFavoriteToggleProps extends StandardDivProps<ProductDetailFavoriteToggleClassKey> {
  productId: string;
}

const themeSettings = { name: 'ProductDetailFavoriteToggle' };
const useStyles = makeStyles(
  () =>
    createStyles<ProductDetailFavoriteToggleClassKey, {}>({
      root: {
        color: 'red',
      },
    }),
  themeSettings,
);

const ProductDetailFavoriteToggle: React.FC<ProductDetailFavoriteToggleProps> = ({
  className,
  classes: pClasses,
  productId,
}) => {
  const classes = useStyles({ classes: pClasses });
  const t = useTranslateWithFallback();
  const toggleIsFavorite = useToggleIsFavorite();
  const isFavorite = useRecoilValue(isFavoriteProductSelector(productId));
  const onToggle = () => toggleIsFavorite(productId);

  return (
    <Tooltip title={isFavorite ? t('app/removeFromFavorites') : t('app/addToFavorites')}>
      <IconButton className={clsx(classes.root, className)} onClick={onToggle}>
        {isFavorite ? <Favorite /> : <FavoriteBorder />}
      </IconButton>
    </Tooltip>
  );
};

export default ProductDetailFavoriteToggle;
